var _, e;
function r() {
  return e ? _ : (e = 1, _ = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
}
export { r as __require };